import React, { lazy, Suspense } from 'react';
import {connect} from 'react-redux';
import {
  BrowserRouter as Router,
  Redirect,
  withRouter,
  Route
} from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { hasAnyRoleExist, hasAnyRoleNotExist, setPanelHeight } from "../actions/utils";
import { removeAllCache } from "../actions/actions";
const AgentIndex = lazy(() => import('../pages/Agent/Home/index'));
const MobileMarketingIndex = lazy(() => import('../pages/Agent/MobileMarketing/index'));
const CompanyList = lazy(() => import('../pages/Agent/Company/list'));
const CompanyDetail = lazy(() => import('../pages/Agent/Company/detail'));
const CompanyCreate = lazy(() => import('../pages/Agent/Company/create'));
const UserList = lazy(() => import('../pages/Agent/User/list'));
const UserCreate = lazy(() => import('../pages/Agent/User/create'));
const ProductList = lazy(() => import('../pages/Agent/Product/list'));
const ProductCreate = lazy(() => import('../pages/Agent/Product/create'));
const PartnerCreate = lazy(() => import('../pages/Agent/Partner/create'));
const ClientCreate = lazy(() => import('../pages/Agent/Client/create'));
const SuperAdminCreate = lazy(() => import('../pages/Agent/SuperAdmin/create'));
const ClientList = lazy(() => import('../pages/Agent/Client/list'));
const ClientDetail = lazy(() => import('../pages/Agent/Client/detail'));
const PartnerList = lazy(() => import('../pages/Agent/Partner/list'));
const PartnerDetail = lazy(() => import('../pages/Agent/Partner/detail'));
const PartnerAddUser = lazy(() => import('../pages/Agent/Partner/addUser'));
const PartnerEditInfo = lazy(() => import('../pages/Agent/Partner/editInfo'));
const PartnerCreateUser = lazy(() => import('../pages/Agent/Partner/createUser'));
const SalesUserCreate = lazy(() => import('../pages/Agent/Sales/create'));

const renderLoader = () => <p>Loading</p>;

class AgentLayout extends React.Component {
    constructor(props){
        super(props);
    }

    componentDidMount() {
        setPanelHeight();
        window.addEventListener('load', setPanelHeight);
        window.addEventListener('resize', setPanelHeight);
    }
    
    componentWillUnmount() {
        window.removeEventListener('resize', setPanelHeight);
    }

    componentDidUpdate(prevProps, prevState, snapshot)
    {
        setPanelHeight();
    }

    render() {
        if(localStorage.getItem('user') == null || hasAnyRoleNotExist("Sales"))
        {
            localStorage.removeItem('user');
            localStorage.removeItem('userType');
            this.props.dispatch(removeAllCache());
            return (<Redirect
                        to={{
                            pathname: "/",
                            state: { from: this.props.location }
                        }}
                    />
              );
        }

        return (
            <div>
                <Suspense fallback={renderLoader()}>
                    <Header />
                    <Route exact path="/agent" component={AgentIndex} />
                    <Route exact path="/agent/mobileMarketing" component={MobileMarketingIndex} />
                    <Route exact path="/agent/company/list" component={CompanyList} />
                    <Route exact path="/agent/company/create" component={CompanyCreate} />
                    <Route exact path="/agent/company/detail" component={CompanyDetail} />
                    <Route exact path="/agent/company/detail/:id" component={CompanyDetail} />
                    <Route exact path="/agent/company/detail/:id/products" component={ProductList} />
                    <Route exact path="/agent/company/detail/:id/products/create" component={ProductCreate} />
                    <Route exact path="/agent/company/detail/:id/users" component={UserList} />
                    <Route exact path="/agent/company/detail/:id/users/create" component={UserCreate} />
                    <Route exact path="/agent/partner/create" component={PartnerCreate} />
                    <Route exact path="/agent/partner/detail" component={PartnerDetail} />
                    <Route exact path="/agent/partner/list" component={PartnerList} />
                    <Route exact path="/agent/partner/editInfo" component={PartnerEditInfo} />
                    <Route exact path="/agent/partner/:id/createUser" component={PartnerCreateUser} />
                    <Route exact path="/agent/partner/detail/:id" component={PartnerDetail} />
                    <Route exact path="/agent/partner/:id/add/user" component={PartnerAddUser} />
                    <Route exact path="/agent/client/create" component={ClientCreate} />
                    <Route exact path="/agent/superadmin/create" component={SuperAdminCreate} />
                    <Route exact path="/agent/client/list" component={ClientList} />
                    <Route exact path="/agent/client/detail" component={ClientDetail} />
                    <Route exact path="/agent/client/detail/:id" component={ClientDetail} />
                    <Route exact path="/agent/sales/create" component={SalesUserCreate} />
                    <Footer />
                </Suspense>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        app: state.app 
    }
}

export default withRouter(connect(mapStateToProps)(AgentLayout))